/**
 * DeleteIcon/index.js
 * desc: trash can icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const DeleteIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="delete icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.delete.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10.5 1H14V3H0V1H3.5L4.5 0H9.5L10.5 1ZM3 18C1.9 18 1 17.1 1 16V4H13V16C13 17.1 12.1 18 11 18H3Z" /></svg>
    </IconButton>
);


export default DeleteIcon;
